import React from "react";
import ErasEditor from "../components/ErasEditor";

function EditorScreen() {
  return <ErasEditor />;
}

export default EditorScreen;
